/**
 * Extracts the shared snapshot token from the URL hash.
 * Looks for the pattern #tak=<token>
 *
 * @returns {string|null} The token if found, otherwise null.
 */
export function getSharedTokenFromHash() {
  const hashMatch = window.location.hash.match(/#tak=([a-zA-Z0-9_-]+)/);
  return hashMatch && hashMatch[1] ? hashMatch[1] : null;
}
